'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateUpgradeProduct = undefined;

var _validateProperty = require('ui-addon-upgrades/_core/common/data/upgradeData/validators/validateProperty');

var _upgradeProducts = require('ui-addon-upgrades/_core/common/data/upgradeData/properties/upgradeProducts');

var validateUpgradeProduct = exports.validateUpgradeProduct = function validateUpgradeProduct(upgradeProduct) {
  var isValidUpgradeProduct = _upgradeProducts.upgradeProductValues.indexOf(upgradeProduct) !== -1;

  return (0, _validateProperty.validateProperty)(isValidUpgradeProduct, 'expected upgradeProduct to be one of ' + _upgradeProducts.upgradeProductValues + ' but got ' + upgradeProduct, 'upgradeProduct');
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/data/upgradeData/validators/validateUpgradeProduct.js
// module id = 443
// module chunks = 3 4 5